import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const MasterData = Loader(
  lazy(
    () =>
      import('src/content/admin-content/package-master-management/master-data')
  )
);
const CreateMasterData = Loader(
  lazy(
    () =>
      import(
        'src/content/admin-content/package-master-management/AddOrEditMasterDataDialog'
      )
  )
);
const LocationMaster = Loader(
  lazy(
    () =>
      import(
        'src/content/admin-content/package-master-management/location-master'
      )
  )
);

const masterDataRoutesAdmin = [
  {
    path: '',
    element: <Navigate to="master-data" replace />
  },

  {
    path: 'master-data',
    element: <MasterData />
  },

  {
    path: 'add-or-update-master-data',
    element: <CreateMasterData />
  },

  {
    path: 'location-master',
    element: <LocationMaster />
  }
];

export default masterDataRoutesAdmin;
